import React from "react";
import "../styles.css";

const Accountpage = () => {
  return (
    <div className="page-content">
      <h2>Account Page</h2>
      <p>Under Construction...</p>
    </div>
  );
};

export default Accountpage;
